import TargetSocialNetworkSelect from "./TargetSocialNetworkSelect.svelte";
import SignUpForm from "./auth/SignUpForm.svelte";
import SignInForm from "./auth/SignInForm.svelte";
import PasswordResetForm from "./auth/PasswordResetForm.svelte";
import ChangePasswordForm from "./auth/ChangePasswordForm.svelte";
import SupportRequestWidget from "./support/SupportRequestWidget.svelte";
function createTargetSocialNetworkSelect(wrapId, params = {}) {
    return new TargetSocialNetworkSelect({
        target: document.getElementById(wrapId),
        props: params
    });
}
window['createTargetSocialNetworkSelect'] = createTargetSocialNetworkSelect;
window['signUpFormRegister'] = (target, props) => {
    return new SignUpForm({ target, props });
};
window['signInFormRegister'] = (target, props) => {
    return new SignInForm({ target, props });
};
window['passwordResetFormRegister'] = (target, props) => {
    return new PasswordResetForm({ target, props });
};
window['changePasswordFormRegister'] = (target, props) => {
    return new ChangePasswordForm({ target, props });
};
window['supportRequestWidgetRegister'] = (target, props) => {
    return new SupportRequestWidget({ target, props });
};
